export const totalizer = () => {
	// https://codepen.io/vajkri/pen/VJKgRa

	const total = document.querySelector('[data-total]')

	if (total) {

		let start = 0

		// Get total value from data attribute
		const totalValue = document.querySelector('[data-total]').getAttribute('data-total') * 100

		// Set inital value for page load
		total.innerHTML = start

		// Count up function
		const countUp = (count) => {

			count++

			total.innerHTML = (count * 0.01).toFixed(2)

			if (count < totalValue) {
				setTimeout(() => countUp(count), 20)
			}
		}

		// Fire on page load
		document.addEventListener('DOMContentLoaded', countUp(start))

	} else {
		return false
	}

}

export default () => { }